export enum DatetimeType {
    Date = 'date',
    Time = 'time',
    DateTime = 'datetime',
}
